"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TwoFactorForm = void 0;
var _react = _interopRequireDefault(require("react"));
var _reactstrap = require("reactstrap");
var _reactI18next = require("react-i18next");
var _styledComponents = _interopRequireDefault(require("styled-components"));
var yup = _interopRequireWildcard(require("yup"));
var _reactHookForm = require("react-hook-form");
var _yup2 = require("@hookform/resolvers/yup");
var _validations = require("../../../../../validations");
var _state = require("../../../../../state");
var _ui = require("../../../../ui");
var _TimerTextButton = require("../../../../TimerTextButton");
var _fields = require("../../../../fields");
var _templateObject;
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
var LabelWrapper = _styledComponents.default.div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  display: flex;\n  justify-content: space-between;\n  align-items: baseline;\n"])));
var schema = yup.object().shape({
  withdrawKey: _validations.numericalValidation.length(6).required()
}).required();
var TwoFactorForm = function TwoFactorForm(_ref) {
  var onSubmit = _ref.onSubmit,
    children = _ref.children;
  var _useTranslation = (0, _reactI18next.useTranslation)(['libAuth', 'libSettings']),
    t = _useTranslation.t;
  var _useSendWithdraw2faKe = (0, _state.useSendWithdraw2faKey)(),
    loading = _useSendWithdraw2faKe.loading,
    sendWithdraw2faKey = _useSendWithdraw2faKe.sendWithdraw2faKey,
    remainingTime = _useSendWithdraw2faKe.remainingTime;
  var _useForm = (0, _reactHookForm.useForm)({
      resolver: (0, _yup2.yupResolver)(schema)
    }),
    handleSubmit = _useForm.handleSubmit,
    control = _useForm.control;
  return /*#__PURE__*/_react.default.createElement(_reactstrap.Form, {
    onSubmit: handleSubmit(onSubmit)
  }, /*#__PURE__*/_react.default.createElement(_ui.FormGroup, null, /*#__PURE__*/_react.default.createElement(LabelWrapper, null, /*#__PURE__*/_react.default.createElement(_ui.Label, null, t('codeFromEmail')), /*#__PURE__*/_react.default.createElement(_TimerTextButton.TimerTextButton, {
    loading: loading,
    afterTimeoutClick: sendWithdraw2faKey,
    timeout: remainingTime,
    label: t('sendCode')
  })), /*#__PURE__*/_react.default.createElement(_fields.InputField, {
    control: control,
    inputProps: {
      name: 'withdrawKey',
      placeholder: t('libSettings:your6DigitCode')
    }
  })), children);
};
exports.TwoFactorForm = TwoFactorForm;